export const discoveryCallsList = [
  {
    name: 'My Profile',
    triggerUrl: '/account/:section',
    featureFlagSlug: 'my-profile',
  },
  {
    name: 'Automation - Queue settings',
    triggerUrl: '/queues/:queueId/settings/automation',
    featureFlagSlug: 'queue-settings-automation',
  },
  {
    name: 'Automation - Queues List',
    triggerUrl: '/automation',
    featureFlagSlug: 'automation',
  },
  {
    name: 'Automation - Engines List',
    triggerUrl: '/automation/engines',
    featureFlagSlug: 'automation-engines',
  },
  {
    name: 'Automation - Engine Detail',
    triggerUrl: '/automation/engines/:engineId',
    featureFlagSlug: 'automation-engine',
  },
  {
    name: 'Automation - Engine Field Detail',
    triggerUrl: '/automation/engines/:engineId/fields/:fieldId',
    featureFlagSlug: 'automation-engine-field',
  },
  {
    name: 'Automation - Engine Field - Create new',
    triggerUrl: '/automation/engines/:engineId/fields/new',
    featureFlagSlug: 'automation-engine-field-new',
  },
  {
    name: 'Automation - Engine - Create new',
    triggerUrl: '/automation/engines/new',
    featureFlagSlug: 'automation-engine-new',
  },
  {
    name: 'Billing - History',
    triggerUrl: '/billing/history',
    featureFlagSlug: 'billing-history',
  },
  {
    name: 'Billing - My Plan',
    triggerUrl: '/billing/my-plan',
    featureFlagSlug: 'billing-my-plan',
  },
  {
    name: 'Billing - Overview',
    triggerUrl: '/billing/overview',
    featureFlagSlug: 'billing-overview',
  },
  {
    name: 'Billing - Statistics',
    triggerUrl: '/billing/statistics',
    featureFlagSlug: 'billing-statistics',
  },
  {
    name: 'Document - Edit mode',
    triggerUrl: '/document/:annotationId/edit',
    featureFlagSlug: 'document-edit-mode',
  },
  {
    name: 'Document - Validation screen',
    triggerUrl: '/document/:annotationId?',
    featureFlagSlug: 'document-validation',
  },
  {
    name: 'Documents Dashboard',
    triggerUrl: '/documents',
    featureFlagSlug: 'dashboard-documents',
  },
  {
    name: 'Emails Dashboard',
    triggerUrl: '/emails/:queueId?',
    featureFlagSlug: 'dashboard-emails',
  },
  {
    name: 'Extensions - My Extensions',
    triggerUrl: '/extensions/my-extensions',
    featureFlagSlug: 'extensions-my-extensions',
  },
  {
    name: 'Extensions - Detail',
    triggerUrl: '/extensions/my-extensions/:extensionId',
    featureFlagSlug: 'extensions-detail',
  },
  {
    name: 'Extensions - Detail Code',
    triggerUrl: '/extensions/my-extensions/:extensionId/code',
    featureFlagSlug: 'extensions-detail-code',
  },
  {
    name: 'Extensions - Create new',
    triggerUrl: '/extensions/my-extensions/create',
    featureFlagSlug: 'extensions-new',
  },
  {
    name: 'Extensions - Store',
    triggerUrl: '/extensions/store',
    featureFlagSlug: 'extensions-store',
  },
  {
    name: 'Approval Workflows - Requests',
    triggerUrl: '/requests',
    featureFlagSlug: 'approval-workflows-requests',
  },
  {
    name: 'Settings',
    triggerUrl: '/settings',
    featureFlagSlug: 'settings',
  },
  {
    name: 'Datasets - List',
    triggerUrl: '/settings/datasets',
    featureFlagSlug: 'datasets-list',
  },
  {
    name: 'Datasets - Details',
    triggerUrl: '/settings/datasets/:id/details',
    featureFlagSlug: 'datasets-detail',
  },
  {
    name: 'Datasets - Settings',
    triggerUrl: '/settings/datasets/:id/settings',
    featureFlagSlug: 'datasets-detail-settings',
  },
  {
    name: 'Datasets - Create new',
    triggerUrl: '/settings/datasets/create',
    featureFlagSlug: 'datasets-new',
  },
  {
    name: 'Field Manager',
    triggerUrl: '/settings/field-manager',
    featureFlagSlug: 'field-manager',
  },
  {
    name: 'Field Manager - Detail',
    triggerUrl: '/settings/field-manager/detail/:schemaId',
    featureFlagSlug: 'field-manager-detail',
  },
  {
    name: 'Field Manager - Create field',
    triggerUrl:
      '/settings/field-manager/schema/:schemaId/parent/:parentId/create-field',
    featureFlagSlug: 'field-manager-create-field',
  },
  {
    name: 'Labels',
    triggerUrl: '/settings/labels',
    featureFlagSlug: 'labels',
  },
  {
    name: 'Rules - List',
    triggerUrl: '/queues/:queueId/settings/rules',
    featureFlagSlug: 'rules-list',
  },
  {
    name: 'Rules - Detail',
    triggerUrl: '/queues/:queueId/settings/rules/:ruleId/detail',
    featureFlagSlug: 'rules-detail',
  },
  {
    name: 'Users - List',
    triggerUrl: '/settings/users',
    featureFlagSlug: 'users-list',
  },
  {
    name: 'Users - Detail (Access)',
    triggerUrl: '/settings/users/:userId/access',
    featureFlagSlug: 'user-detail-access',
  },
  {
    name: 'Users - Detail (Info)',
    triggerUrl: '/settings/users/:userId/info',
    featureFlagSlug: 'user-detail-info',
  },
  {
    name: 'Statistics',
    triggerUrl: '/statistics',
    featureFlagSlug: 'statistics',
  },
] as const;

export type DiscoveryCall = (typeof discoveryCallsList)[number];

export type FeatureFlagSlug =
  (typeof discoveryCallsList)[number]['featureFlagSlug'];
